import type { ProductConfig } from '#types/config/components/product'
import type { RecursivePartial } from '#types/utils'

export default {
  dialogOptions: { type: 'modal' }
} satisfies RecursivePartial<ProductConfig['notifyMe']>
